import { RouteType } from "@/common/hooks/amplitude/useLogRouteChangePageVisits";
import { SupportChannel } from "@/components/ChatWidgetVisibilityManager/helpers/usePublishSupportChannel";

interface OrganizationAssistantGateStateInput {
  channel: SupportChannel;
  routeType: RouteType;
  isClientReady: boolean;
  isHiddenByRoute: boolean;
}

interface OrganizationAssistantGateState {
  publish: boolean;
  suppressForethought: boolean;
  showWidget: boolean;
}

export const getOrganizationAssistantGateState = ({
  channel,
  routeType,
  isClientReady,
  isHiddenByRoute,
}: OrganizationAssistantGateStateInput): OrganizationAssistantGateState => ({
  publish: isClientReady && routeType === RouteType.OrganizationRoute,
  suppressForethought: channel !== "forethought",
  showWidget: channel === "assistant" && !isHiddenByRoute,
});
